import { H6, P } from "../../../../AbstractElements";
import { ActivityLogData } from "../../../../Data/Applications/SocialApp/SocialApp";
import { MyActivityProp } from "../../../../Types/SocialAppType";

const MyActivity:React.FC<MyActivityProp> = ({ heading }) => {
  return (
    <div className="my-activity">
      <H6 className="f-w-600 mb-3">{heading}</H6>
      {ActivityLogData.map((item) => (
        <P key={item.id}>
          <span>{item.icon}</span>
          {item.description}
        </P>
      ))}
    </div>
  );
};

export default MyActivity;
